import { Field, useFormikContext } from "formik";
import { FC, useCallback } from "react";

import __ from "web/Layout/Translations";

import CloseIcon from "web/assets/icons/close.svg";
import Magnifier from "web/assets/icons/magnifier.svg";

import classes from "./searchField.scss";

interface ISearchAutocompleteSearchFieldMobileProps {
  name: string;
  currentValue: string;
  variant?: "default" | "header";
}

const SearchAutocompleteSearchFieldMobile: FC<
  ISearchAutocompleteSearchFieldMobileProps
> = ({ name, currentValue, variant = "default" }) => {
  const { setFieldValue } = useFormikContext();
  const clearHandler = useCallback(() => {
    setFieldValue(name, "");
  }, [setFieldValue, name]);

  const rootClassName =
    variant === "header" ? classes.rootHeader : classes.root;
  const inputBaseClassName =
    variant === "header" ? classes.inputHeader : classes.input;
  const inputWithClearClassName =
    variant === "header" ? classes.inputHeaderWithClear : classes.inputWithClear;
  const submitClassName =
    variant === "header" ? classes.submitHeader : classes.submit;
  const clearBaseClassName =
    variant === "header" ? classes.clearHeader : classes.clear;
  const clearHiddenClassName =
    variant === "header" ? classes.clearHeaderHidden : classes.clearHidden;

  const clearButtonClassName = currentValue
    ? clearBaseClassName
    : clearHiddenClassName;

  return (
    <div className={rootClassName}>
      <button
        className={submitClassName}
        type="submit"
        data-t1="search_submit"
        aria-label={__("Wyszukaj")}
      >
        <Magnifier width={26} />
      </button>
      <Field
        className={`${inputBaseClassName} ${
          currentValue ? inputWithClearClassName : ""
        }`}
        type="text"
        name={name}
        placeholder={__("Czego szukasz?")}
        autoComplete="off"
        data-t1="search_input"
        aria-label={__("Wpisz wyszukiwaną frazę")}
      />
      <button
        className={clearButtonClassName}
        type="button"
        onClick={clearHandler}
        data-t1="search_clear"
        aria-label={__("Wyczyść wyszukiwaną frazę")}
      >
        <CloseIcon width={18} />
      </button>
    </div>
  );
};

export default SearchAutocompleteSearchFieldMobile;
